import { useFormContextRequired } from "ui-builder";
import { ProjectDetailsField, ProjectDetailsFieldType } from "nekst-api";
import React from "react";
import { InformationMessage } from "features/nekst-widgets";

export function IsStartDateFieldInput() {
  const formContext = useFormContextRequired<ProjectDetailsField>();


  if (formContext.data?.isProjectStartDate) {
    return (
      <InformationMessage withoutMargin>
          This detail box will be used as the start date when creating transactions from contracts.
        </InformationMessage>
    )
  } else {
    return null;
  }
}

export function IsEndDateMessage() {
  const formContext = useFormContextRequired<ProjectDetailsField>();

  if (formContext.data?.isProjectEndDate) {
    return (
      <InformationMessage withoutMargin>
          This detail box will be used as the end date when creating transactions from contracts.
        </InformationMessage>
    )
  } else {
    return null;
  }
}

export function DatesFieldsInput() {

  const formContext = useFormContextRequired<ProjectDetailsField>();

  if (formContext.data?.fieldType === ProjectDetailsFieldType.DATE) {
    return (
      <>
        <IsStartDateFieldInput />
        <IsEndDateMessage />
      </>
    );
  } else {
    return null;
  }
}
